import React from "react";
import { finalCta } from "../data/salesCopy";
import { Countdown } from "./Countdown";
import { PricingCards } from "./PricingCards";
export function FinalCta() {
  return <section data-hide-sticky className="bg-chalk-soft py-9 md:py-16" data-id="element-91" data-mp="19ez2tgggle3r">
      <div className="mx-auto max-w-5xl px-5" data-id="element-92" data-mp="19ga2p56sa1pl">
        <h2 className="text-center font-display text-2xl font-bold md:text-4xl" data-id="element-93" data-mp="15cu7mdad49f0">{finalCta.title}</h2>
        <p className="mt-2 text-center text-xs font-bold tracking-wide text-coral md:mt-4 md:text-sm" data-id="element-94" data-mp="1jcd60eddg6e4">{finalCta.endsIn}</p>
        <div className="mt-2 md:mt-4" data-id="element-95" data-mp="1ed8zjvhu0mrh">
          <Countdown data-id="element-96" data-mp="1ec7k7ets9e3y" />
        </div>
        <div className="mt-6 md:mt-12" data-id="element-97" data-mp="1t37s9iqmb5zk">
          <PricingCards data-id="element-98" data-mp="1t251rbx7j5k6" />
        </div>
      </div>
    </section>;
}